import { styled } from '@lichtblick/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  > svg {
    height: 0.75rem;
  }
`;
